import { useQuery } from "react-query";
import API from "../shared-utils/api";
import { useCustomer } from "../contexts/CustomerProvider";
const EMPTY_ELIGIBILITY = {
    eligible: false,
    feedbackSubmitted: false,
};
const getRecentPubBookingEligibility = async (userId, pubId) => {
    if (!userId || !pubId)
        return EMPTY_ELIGIBILITY;
    const { data } = await API.get("/api/v1/rbzo/reviews/experience/eligibility", {
        params: { pubId },
    });
    if ((data === null || data === void 0 ? void 0 : data.status_code) === "OK" && (data === null || data === void 0 ? void 0 : data.data)) {
        return {
            eligible: !!data.data.eligible,
            feedbackSubmitted: !!data.data.feedbackSubmitted,
        };
    }
    return EMPTY_ELIGIBILITY;
};
export const useRecentPubBooking = (pubId, enabled = true) => {
    const { customerData } = useCustomer();
    const userId = customerData === null || customerData === void 0 ? void 0 : customerData.id;
    return useQuery(["recentPubBooking", userId, pubId], () => getRecentPubBookingEligibility(userId, pubId), {
        enabled: enabled && !!userId && !!pubId,
        staleTime: 5 * 60 * 1000,
        cacheTime: 10 * 60 * 1000,
    });
};
